import React, {useEffect, useState, useContext, useMemo} from 'react';
import Select from 'react-select';
import { Campaign, CampaignRequest, addCampaign, updateCampaign, CampaignSettings } from "../campaign-api";
import { listAudiences } from '../audience-api';
import { Modal, useModalHide } from '../components/Modal';
import { SavingButton } from '../components/SavingButton';
import { CampaignContext } from './campaign-context';
import { useErrorAlert } from '../components/use-animation';
import { Alert } from '../components/Alert';
import { MediaMenu } from '../media/media-selector';
import { SpeedMenu } from './speed-menu';

export function AudienceMenu({value, onChange}:{value:number, onChange:(v:number, label?:string) => void}){
    const [options, setOptions] = useState<{value: number, label: string}[]>(null);
    const selected = useMemo(() => {
        if(options == null) return null;
        return options.find(o => o.value == value)
    }, [options, value])

    useEffect(() => {
        (async () => {
            const audiences = await listAudiences();
            setOptions(audiences.map(a => ({value: a.id, label: a.name})));
        })()
    }, [])

    if(options?.length === 0)
        return <>Nenhum público criado</>

    return <Select classNamePrefix="react-select-city" placeholder="Público..." noOptionsMessage={() => "Não encontrado"} isLoading={options == null} options={options} value={selected} onChange={(e:any) => onChange(e.value, e.label)} />
}

function validateForm(campaign:CampaignRequest){
    if(!campaign.name) throw "Escolha um título";
    if(!campaign.audience) throw "Escolha um público";
}

function updateSettings(settings:CampaignSettings, value:Partial<CampaignSettings>): CampaignSettings{
    if(!settings) return value
    return {...settings, ...value};
}

function CampaignFormModal({campaign}:{campaign:Campaign | CampaignRequest}){
    const [state, setState] = useState(campaign);
    const addMode = !('id' in campaign);
    const [saving, setSaving] = useState(false);
    const hide = useModalHide()
    const [error, setError, shakeClass] = useErrorAlert()
    const {state:{bot, campaigns}, dispatch} = useContext(CampaignContext);

    async function doSave(){
        setSaving(true);
        let savedCampaign:Campaign;
        
        try{
            validateForm(state)
            savedCampaign = await (addMode ?  addCampaign(bot, state) : updateCampaign(bot, state as Campaign));
            setSaving(false);
        }catch(e){
            setSaving(false);
            console.error(e)
            setError(typeof e == 'string' ? e : "Erro ao salvar campanha");
            return 
        }
        
        if(addMode){
            dispatch({type:'setCampaigns', list: campaigns ? [...campaigns, savedCampaign] : [savedCampaign]})
        } else {
            dispatch({type:'setCampaigns', list: campaigns.map(c => c.id == savedCampaign.id ? savedCampaign : c)})
        }


        hide();
    }

    return <>
        <div className='mb-1'>Título:</div>
        <input className="form-control" value={state.name} onChange={(e) => setState({...state, name: e.target.value})} />
        <div className='mt-3 mb-1'>Público:</div>
        <AudienceMenu value={state.audience} onChange={(e) => setState({...state, audience: e})} />

        { /* <div className='mt-3 mb-1'>Mídia:</div>
        <MediaMenu value={state.media} onChange={(e) => setState({...state, media: e})} /> */ }

        <SpeedMenu speed={state.settings?.speed} onChange={ speed => 
             setState({...state, settings: updateSettings(state.settings, {speed})})
            } />

        {error && <Alert content={error} className={`alert-danger ${shakeClass}`} />}
        <div className='mt-4 text-end'>
            <button className='btn btn-outline-primary' onClick={hide}>Cancelar</button>
            <SavingButton saving={saving} className='ms-2 btn btn-primary' onClick={doSave} icon='fa-save'>Salvar</SavingButton>
        </div>
    </>
}


export function AddCampaignButton(){
    const [show, setShow] = useState(false);
    return <div className='mt-4'>
        <button className='btn btn-primary' onClick={() => setShow(true)}>Adicionar Campanha</button>
        {show && <Modal title="Nova Campanha" onHide={() => setShow(false)}><CampaignFormModal campaign={{audience: null, template: "", name: "", media: null}} /> </Modal>}
    </div>
}

export function EditCampaignModal(){
    const {state:{editCampaign}, dispatch} = useContext(CampaignContext);

    if(!editCampaign) return null;

    return <Modal title={editCampaign.name} onHide={() => dispatch({type:"setEditCampaign", campaign: null})}>
            <CampaignFormModal campaign={editCampaign} /> 
        </Modal>
}